import React, { useEffect, useRef, useContext, useState } from "react";
import { useReport } from "../.././contexts/ReportContext";
import { useUpdate } from "../.././contexts/UpdateContext";
import { NavigationContext } from "../../contexts/NavigationContext";
import { postReport } from "../../api/api";

import { StyledButton } from "../../components/styles/buttons/Buttons";
import { LoadingSpinner } from "../../components/styles/Spinners/Spinners";
import {
  StyledHeroHeadingThin,
  StyledSpanWord,
  StyledBoldHeader,
  StyledTextFollowUp,
  StyledInfoText,
  StyledText,
} from "../../components/styles/Typography/Typography";

import {
  StyledButtonOuter,
  StyledButtonInner,
  StyledHeroContainer,
  StyledHeaderContainerText,
  StyledFlexCenter,
} from "../../components/styles/containers/Containers";

import {
  StyledError,
  StyledFormWrapper,
  StyledInput,
  StyledLabel,
  StyledFollowUpLabel,
  StyledCheckBox,
  StyledFollowUpBox,
  StyledFormDescription,
} from "../../components/styles/form/Form";
//prettier-ignore
const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line
const mobilePattern =
  /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;

const ContactInfoView = () => {
  const { setCurrentViewHeading } = useUpdate();
  const name = useRef("");
  const email = useRef("");
  const phone = useRef("");
  const enable_tracking = useRef(false);
  const {
    handelSetFormInfo,
    formState,
    dispatch: reportDispatch,
  } = useReport();
  const [isLoading, setIsLoading] = useState(false);
  const [pageIsValid, setPageIsValid] = useState(true);
  const { dispatch } = useContext(NavigationContext);
  const REGISTRATION_TYPE = process.env.REACT_APP_REGISTRATION_TYPE;
  const handelFormInfo = (e) => {
    handelSetFormInfo("name", name.current.value);
    handelSetFormInfo("email", email.current.value);
    handelSetFormInfo("phone", phone.current.value);
    handelSetFormInfo("enable_tracking", enable_tracking.current.checked);
  };

  useEffect(() => {
    document.title = "Felanmälan - Ange kontaktuppgifter";
    const regIsExternal = REGISTRATION_TYPE === "external";
    setCurrentViewHeading(
      // <StyledHeroContainer role="heading">
      //   <StyledHeroHeadingThin>
      //     <StyledSpanWord>Kan</StyledSpanWord> vi{" "}
      //     <StyledSpanWord>kontakta</StyledSpanWord> dig vid
      //     <StyledSpanWord> frågor</StyledSpanWord>?
      //   </StyledHeroHeadingThin>
      //   {REGISTRATION_TYPE === "external" && (
      //     <StyledInfoText>
      //       Uppgifterna används för att vi eller vår entreprenör ska kunna
      //       kontakta dig vid frågor eller för att återkoppla om ärendet.
      //     </StyledInfoText>
      //   )}
      // </StyledHeroContainer>
      <StyledHeroContainer>
        <StyledHeroHeadingThin>
          <StyledSpanWord>Kan</StyledSpanWord> vi{" "}
          <StyledSpanWord>kontakta</StyledSpanWord> dig vid
          <StyledSpanWord> frågor</StyledSpanWord>?
        </StyledHeroHeadingThin>
        {regIsExternal && (
          <StyledText>
            Uppgifterna används för att vi eller vår entreprenör ska kunna
            kontakta dig vid frågor eller för att återkoppla om ärendet.
          </StyledText>
        )}
        {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
      </StyledHeroContainer>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isEmptyPhoneNumberInput =
    !phone.current.value ||
    (phone.current.value && phone.current.value.length === 0);

  const isEmptyEmailInput =
    !email.current.value ||
    (email.current.value && email.current.value.length === 0);

  const isValidEmail = emailPattern.test(email.current.value);

  const isValidPhoneNumber = mobilePattern.test(phone.current.value);

  // Kontrollera om minst ett kontaktfält är ifyllt och giltigt
  const atLeastOneContactFilled = () => {
    return (
      (!isEmptyEmailInput && isValidEmail) ||
      (!isEmptyPhoneNumberInput && isValidPhoneNumber)
    );
  };

  // För "enable_tracking" krävs kontaktuppgift, annars gäller REGISTRATION_TYPE
  const trackingRequirementsFulfilled = () => {
    return atLeastOneContactFilled();
  };

  // För "intern" registrering krävs kontaktuppgift
  const contactEmailPhoneFulfilled = () => {
    if (REGISTRATION_TYPE !== "external") {
      return atLeastOneContactFilled();
    }
    // För extern: bara validera om något är ifyllt
    if (
      (!isEmptyPhoneNumberInput && !isValidPhoneNumber) ||
      (!isEmptyEmailInput && !isValidEmail)
    ) {
      return false;
    }
    return true;
  };
  const shouldRenderPhoneError = () => {
    if (isEmptyPhoneNumberInput) {
      return false;
    }
    if (!isValidPhoneNumber) {
      return true;
    }
  };

  const shouldRenderEmailError = () => {
    if (isEmptyEmailInput) {
      return false;
    }
    if (!isValidEmail) {
      return true;
    }
  };
  return (
    <>
      <StyledFormWrapper>
        <StyledFormDescription>
          <div>
            <StyledLabel htmlFor="contactName" id="lblContactName">
              <StyledBoldHeader>Namn (frivilligt)</StyledBoldHeader>
              <StyledInput
                id="contactName"
                type="text"
                name="name"
                autocomplete="name"
                defaultValue={formState.name}
                ref={name}
                onChange={handelFormInfo}
              />
            </StyledLabel>
          </div>
          <div>
            <StyledLabel htmlFor="contactEmail" id="lblEmail">
              <StyledBoldHeader>
                E-post
                {REGISTRATION_TYPE === "external" &&
                !enable_tracking.current.checked
                  ? " (frivilligt)"
                  : ""}
              </StyledBoldHeader>
              {shouldRenderEmailError() && (
                <StyledError aria-live="assertive" id="errorEmail">
                  * Skriv in en e-postadress som innehåller ett @-tecken, såsom
                  namn@exempel.se
                </StyledError>
              )}
              <StyledInput
                aria-labelledby="lblEmail"
                aria-invalid={shouldRenderEmailError()}
                aria-describedby="errorEmail"
                type="email"
                name="email"
                autocomplete="email"
                id="contactEmail"
                defaultValue={formState.email}
                ref={email}
                onChange={handelFormInfo}
              />
            </StyledLabel>
          </div>
          <div>
            <StyledLabel htmlFor="contactPhone" id="lblPhone">
              <StyledBoldHeader>
                Telefonnummer
                {REGISTRATION_TYPE === "external" &&
                !enable_tracking.current.checked
                  ? " (frivilligt)"
                  : ""}
              </StyledBoldHeader>
              {shouldRenderPhoneError() && (
                <StyledError aria-live="assertive" id="errorPhone">
                  * Skriv in ett telefonnummer med siffror, till exempel
                  070-1234567
                </StyledError>
              )}
              <StyledInput
                aria-labelledby="lblPhone"
                aria-invalid={shouldRenderPhoneError()}
                aria-describedby="errorPhone"
                autocomplete="tel"
                type="tel"
                name="phone"
                id="contactPhone"
                defaultValue={formState.phone}
                ref={phone}
                onChange={handelFormInfo}
              />
            </StyledLabel>
          </div>
          <StyledFollowUpBox>
            <StyledCheckBox
              id="contactEnableTracking"
              aria-labelledby="lblEnableTracking"
              aria-describedby="errorValueMissing"
              type="checkbox"
              name="enable_tracking"
              defaultChecked={formState.enable_tracking}
              ref={enable_tracking}
              onChange={handelFormInfo}
            />
            <StyledFollowUpLabel
              id="lblEnableTracking"
              htmlFor="contactEnableTracking"
            >
              {" "}
              Vill du få uppföljning på ditt ärende?
            </StyledFollowUpLabel>
          </StyledFollowUpBox>
          {enable_tracking.current.checked &&
            !trackingRequirementsFulfilled() && (
              <StyledError
                aria-label="Fyll i telefonnummer eller e-post"
                id="errorValueMissing"
              >
                * Fyll i telefonnummer eller e-post
              </StyledError>
            )}
          {/* Visa fel om intern registrering och inget kontaktfält ifyllt */}
          {REGISTRATION_TYPE !== "external" && !atLeastOneContactFilled() && (
            <StyledError
              aria-label="Fyll i telefonnummer eller e-post"
              id="errorValueMissing"
            >
              * Fyll i telefonnummer eller e-post (obligatoriskt)
            </StyledError>
          )}
        </StyledFormDescription>
      </StyledFormWrapper>
      <StyledButtonOuter>
        <StyledButtonInner>
          <StyledButton
            // disabled={isDisabled()}
            onClick={async () => {
              if (
                isLoading ||
                !contactEmailPhoneFulfilled() ||
                (enable_tracking.current.checked &&
                  !trackingRequirementsFulfilled())
              ) {
                return;
              } else {
                setIsLoading(true);
              }
              const response = await postReport(formState);
              reportDispatch({
                type: "setFormInfo",
                field: "external_id",
                payload: response.data.IssueId,
              });
              setIsLoading(false);
              dispatch({ type: "next" });
            }}
          >
            {isLoading ? <LoadingSpinner /> : <span>Skicka in </span>}
          </StyledButton>
          <StyledButton
            secondary
            onClick={() => {
              dispatch({ type: "previous" });
            }}
          >
            Tillbaka
          </StyledButton>
        </StyledButtonInner>
      </StyledButtonOuter>
    </>
  );
};

export default ContactInfoView;
